import { render, staticRenderFns } from "./commissionSetting.vue?vue&type=template&id=42cac62e&scoped=true"
import script from "./commissionSetting.vue?vue&type=script&lang=js"
export * from "./commissionSetting.vue?vue&type=script&lang=js"
import style0 from "./commissionSetting.vue?vue&type=style&index=0&id=42cac62e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cac62e",
  null
  
)

export default component.exports